import { apiRequest } from "@/shared/api/http";
import type { SessionUser } from "@/shared/types/api";

export interface LoginInput {
  email: string;
  password: string;
}

export function login(input: LoginInput): Promise<SessionUser> {
  return apiRequest<SessionUser>("/api/session/login", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function me(): Promise<SessionUser> {
  return apiRequest<SessionUser>("/api/session/me");
}

export function logout(): Promise<Record<string, never>> {
  return apiRequest<Record<string, never>>("/api/session/logout", {
    method: "POST",
  });
}
